import { render, staticRenderFns } from "./MaximizedVideoPanel.vue?vue&type=template&id=f466dbd4&scoped=true&"
import script from "./MaximizedVideoPanel.vue?vue&type=script&lang=js&"
export * from "./MaximizedVideoPanel.vue?vue&type=script&lang=js&"
import style0 from "./MaximizedVideoPanel.vue?vue&type=style&index=0&id=f466dbd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f466dbd4",
  null
  
)

export default component.exports